export enum EAgentProjectQueryKey {
  AGENT_PROJECT = 'agent-project',
  AGENT_LIST_AVAILABLE_PROJECTS = 'agent-list-available-projects',
}
